import ApplicationSerializer from 'eflex/serializers/application';

export default class FileRetentionSerializer extends ApplicationSerializer {
  attrs = {
    defaultCameraConfiguration: {
      embedded: 'always',
    },
  };
}
